if (typeof DiscountCode !== 'function') {
	class DiscountCode extends HTMLElement {
		constructor() {
			super();
			this.input = this.querySelector('#discount-code-input');
			this.button = this.querySelector('[data-js-apply-discount]');
			this.messageContainer = this.querySelector('[data-js-discount-message]');

			this.button.addEventListener('click', this.handleButtonClick.bind(this));
			this.input.addEventListener('keypress', this.handleKeyPress.bind(this));
		}

		handleKeyPress(e) {
			if (e.key === 'Enter') {
				e.preventDefault();
				this.handleButtonClick();
			}
		}

		handleButtonClick() {
			this.applyDiscount();
		}

		async applyDiscount() {
			const discountCode = this.input.value.trim().toUpperCase();

			if (!discountCode) {
				this.showMessage(KROWN.settings.locales.cart_discount_error, 'error');
				return;
			}

			this.setLoading(true);
			this.clearMessage();

			try {
				// Valida o cupom tentando criar um checkout
				const checkoutResponse = await fetch('/cart.js');
				const cart = await checkoutResponse.json();

				// Armazena o cupom nos atributos do carrinho
				const updateResponse = await fetch('/cart/update.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json'
					},
					body: JSON.stringify({
						attributes: {
							'_discount_code': discountCode
						}
					})
				});

				if (!updateResponse.ok) {
					throw new Error('Failed to update cart');
				}

				// Tenta validar o cupom fazendo uma requisição ao checkout
				const validationUrl = `/discount/${encodeURIComponent(discountCode)}`;
				
				fetch(validationUrl, {
					method: 'HEAD',
					redirect: 'manual'
				}).then(() => {
					// Cupom foi aceito, recarrega o carrinho via AJAX
					this.showMessage(KROWN.settings.locales.cart_discount_success, 'success');
					
					// Aguarda um momento para o usuário ver a mensagem
					setTimeout(() => {
						this.refreshCart();
					}, 500);
				}).catch(() => {
					// Mesmo que falhe a validação, armazena o cupom
					// O Shopify validará no checkout
					this.showMessage(KROWN.settings.locales.cart_discount_success, 'success');
					
					setTimeout(() => {
						this.refreshCart();
					}, 500);
				});

			} catch (error) {
				console.error('Error applying discount:', error);
				this.showMessage(KROWN.settings.locales.cart_discount_error, 'error');
				this.setLoading(false);
			}
		}

		refreshCart() {
			// Recarrega o carrinho sem reload da página
			fetch('?section_id=helper-cart')
				.then(response => response.text())
				.then(text => {
					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					if (cartItems) {
						cartItems.innerHTML = cartFormInnerHTML;
						cartItems.ajaxifyCartItems();
					}

					const cartSubtotal = document.getElementById('AjaxCartSubtotal');
					if (cartSubtotal) {
						cartSubtotal.innerHTML = cartSubtotalInnerHTML;
					}

					// Atualiza contadores no header
					document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
						if (cartItems) {
							const countElm = cartItems.querySelector('[data-cart-count]');
							if (countElm) elm.textContent = countElm.textContent;
						}
					});

					document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
						if (cartItems) {
							const totalElm = cartItems.querySelector('[data-cart-total]');
							if (totalElm) elm.textContent = totalElm.textContent;
						}
					});

					// Dispara evento de atualização
					const event = new Event('cart-updated');
					document.dispatchEvent(event);
				})
				.catch(error => {
					console.error('Error refreshing cart:', error);
					// Em caso de erro, recarrega a página
					window.location.reload();
				});
		}

		showMessage(message, type) {
			this.messageContainer.textContent = message;
			this.messageContainer.className = `discount-code__message discount-code__message--${type}`;
			this.messageContainer.style.display = 'block';
		}

		clearMessage() {
			this.messageContainer.textContent = '';
			this.messageContainer.style.display = 'none';
		}

		setLoading(loading) {
			if (loading) {
				this.button.classList.add('processing');
				this.button.disabled = true;
			} else {
				this.button.classList.remove('processing');
				this.button.disabled = false;
			}
		}
	}

	if (typeof customElements.get('discount-code') === 'undefined') {
		customElements.define('discount-code', DiscountCode);
	}
}

// Função para remover cupom aplicado
if (typeof RemoveDiscount !== 'function') {
	class RemoveDiscount extends HTMLElement {
		constructor() {
			super();
			this.addEventListener('click', this.removeDiscount.bind(this));
		}

		async removeDiscount(e) {
			e.preventDefault();
			e.stopPropagation();
			
			console.log('🗑️ Removendo cupom...');
			
			// Adiciona estado de carregamento
			this.classList.add('processing');
			
			try {
				// ★ CHAVE: Enviar discount="" (vazio) para remover TODOS os cupons
				console.log('📝 Enviando discount="" para remover cupom...');
				
				const response = await fetch('/cart/update.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json'
					},
					body: JSON.stringify({
						discount: "",  // ★ String vazia remove TODOS os cupons
						attributes: {
							'_discount_code': ''  // Também limpa o atributo
						}
					})
				});

				if (!response.ok) {
					throw new Error('Failed to remove discount');
				}

				const result = await response.json();
				console.log('✅ Discount removed:', result);

				// Atualiza UI via AJAX
				setTimeout(() => {
					this.refreshCart();
				}, 300);
				
			} catch (error) {
				console.error('❌ Error removing discount:', error);
				this.classList.remove('processing');
				alert('Erro ao remover cupom. Tente novamente.');
			}
		}

		refreshCart() {
			console.log('Refreshing cart after removing discount...');
			
			fetch('?section_id=helper-cart')
				.then(response => response.text())
				.then(text => {
					console.log('Cart section fetched successfully');
					
					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartFormElement = document.getElementById('AjaxCartForm');
					if (cartFormElement) {
						cartFormElement.innerHTML = cartFormInnerHTML;
						// Re-inicializa os event listeners do carrinho
						const cartForm = document.querySelector('cart-form');
						if (cartForm && typeof cartForm.ajaxifyCartItems === 'function') {
							cartForm.ajaxifyCartItems();
						}
					}

					const cartSubtotal = document.getElementById('AjaxCartSubtotal');
					if (cartSubtotal) {
						cartSubtotal.innerHTML = cartSubtotalInnerHTML;
					}

					// Atualiza contadores no header
					document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
						const countElm = document.querySelector('[data-cart-count]');
						if (countElm) elm.textContent = countElm.textContent;
					});

					document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
						const totalElm = document.querySelector('[data-cart-total]');
						if (totalElm) elm.textContent = totalElm.textContent;
					});

					console.log('Cart updated successfully');

					// Dispara evento de atualização
					const event = new Event('cart-updated');
					document.dispatchEvent(event);
				})
				.catch(error => {
					console.error('Error refreshing cart:', error);
					alert('Erro ao atualizar carrinho. A página será recarregada.');
					window.location.reload();
				});
		}
	}

	if (typeof customElements.get('remove-discount') === 'undefined') {
		customElements.define('remove-discount', RemoveDiscount);
	}
}

